import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NavigationTab, NavigationTabList } from 'app/types/ui/grouping'
import { updateTabDisabledStates } from './navigateToPage'
import { MAIN_TAB_LIST } from 'app/app/(client)/utils/client-constants'

interface NavigationState {
  opportunityId: string | null
  mainTabList: NavigationTabList[]
  hasUnsavedChanges: boolean
  onDiscardChanges?: () => void
  cameFromContractRenewalSwitch: boolean
}

const initialState: NavigationState = {
  opportunityId: null,
  mainTabList: [
    { labelKey: 'navigation.prepare', value: MAIN_TAB_LIST.prepare, isDisabled: true },
    { labelKey: 'navigation.refresh.grouping', value: MAIN_TAB_LIST.grouping, isDisabled: true },
    { labelKey: 'navigation.refresh.offer', value: MAIN_TAB_LIST.offers, isDisabled: true },
    { labelKey: 'navigation.contract', value: MAIN_TAB_LIST.contract, isDisabled: true }
  ],
  hasUnsavedChanges: false,
  onDiscardChanges: undefined,
  cameFromContractRenewalSwitch: false
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setUnsavedChangesWarning: (
      state,
      action: PayloadAction<{ hasUnsavedChanges: boolean; onDiscardChanges?: () => void }>
    ) => {
      const { hasUnsavedChanges, onDiscardChanges } = action.payload
      state.hasUnsavedChanges = hasUnsavedChanges
      state.onDiscardChanges = onDiscardChanges
    },
    allowTabAccess: (state, action: PayloadAction<NavigationTab>) => {
      const tabValue = action.payload
      const currMainTabList = state.mainTabList
      state.mainTabList = updateTabDisabledStates(currMainTabList, tabValue)
    },
    setCameFromContractRenewalSwitch: (state, action: PayloadAction<boolean>) => {
      state.cameFromContractRenewalSwitch = action.payload
    }
  }
})

export const { setUnsavedChangesWarning, allowTabAccess, setCameFromContractRenewalSwitch } = navigationSlice.actions

export default navigationSlice.reducer
